import Logo from '../assets/icons/new_logo.svg';

/**
 * Default logo URL to use when team has no custom logo
 */
export const DEFAULT_TEAM_LOGO = Logo;

/**
 * Get the display logo URL with fallback to default
 * @param pictureUrl - Team's custom picture URL from database
 * @param teamLogoTag - Team logo from tags (legacy fallback)
 * @returns The logo URL to display
 */
export const getTeamLogoUrl = (
  pictureUrl?: string,
  teamLogoTag?: string | null,
): string => {
  return pictureUrl || teamLogoTag || DEFAULT_TEAM_LOGO;
};

/**
 * Check if the current logo is a custom uploaded logo
 * @param pictureUrl - Team's custom picture URL from database
 * @returns true if custom logo exists
 */
export const isCustomTeamLogo = (pictureUrl?: string): boolean => {
  return !!pictureUrl;
};

/**
 * Add cache-busting parameter to image URL to force reload
 * @param url - The image URL
 * @returns URL with cache-busting timestamp
 */
export const addCacheBuster = (url: string): string => {
  if (!url || url === DEFAULT_TEAM_LOGO) {
    return url; // Don't add cache buster to default logo
  }
  // Skip S3 signed URLs - they already have unique signatures and adding
  // extra query params may invalidate the signature
  if (url.includes('X-Amz-')) {
    return url;
  }
  const timestamp = Date.now();
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${timestamp}`;
};
